import React from 'react';
import './choiceDebtSubscription.css';
import { useDispatch, useSelector } from "react-redux";
import { removeDebtWorkoutSagaAction } from "../../redux/sagaActions";
import { removeDebtAction } from "../../redux/rootReducer";
import { REMOVE_DEBT_INITIAL } from "../../redux/initialStateConstant";

const ChoiceDebtSubscription = () => {
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.currentUser);
    const removeDebt = useSelector(state => state.removeDebt);

    if (!removeDebt.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => dispatch(removeDebtAction(REMOVE_DEBT_INITIAL)) } />
                        <div className="form__title">Доступные абонементы</div>
                    </div>
                    <div className="form__field">
                        <div className="s__items">
                            {
                                currentUser.subscriptions.map(elem => {
                                    return (
                                        <div className="s__item"
                                            key={ elem.id }
                                            onClick={ () => {
                                                if (window.confirm('Вы действительно хотите удалить задолженность?')) {
                                                    dispatch(removeDebtWorkoutSagaAction({
                                                        user: currentUser.id,
                                                        workout_id: removeDebt?.workout_id,
                                                        subscription_id: elem.id
                                                    }));
                                                }
                                            } }
                                        >
                                            <div className="s__cell">{ elem.type?.name }</div>
                                            <div className="s__cell">{ `${ elem.workouts_done } / ${ elem.times }` }</div>
                                            <div className="s__cell">{ elem.expire_date }</div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        <div className="s__one-time"
                             onClick={ () => {
                                 if (window.confirm('Вы действительно хотите удалить задолженность?')) {
                                     dispatch(removeDebtWorkoutSagaAction({
                                         user: currentUser.id,
                                         workout_id: removeDebt?.workout_id,
                                         subscription_id: ''
                                     }));
                                 }
                             } }
                        >Разовое посещение</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChoiceDebtSubscription;